import { Logger } from 'common/logger';
import { JOB_CURRENT_STATE_INTERVAL } from 'common/constants';
import { checkWebsocketConnection } from 'common/saga-utils';

const operations = {
    name: 'operations',
    state: {},
    polling: null,
    effects: (dispatch) => ({
        async startCurrentStateJob() {
            await checkWebsocketConnection();
            const startPolling = () => {
                dispatch({
                    type: 'webSocket/requestCurrentState',
                });
            };
            // Start the polling
            startPolling();
            const polling = setInterval(startPolling, JOB_CURRENT_STATE_INTERVAL);
            dispatch.operations.setPolling(polling);
        },

        stopCurrentStateJob() {
            Logger.info('Stopping history job');
            dispatch.operations.clearPolling(); // Clear polling when this action is dispatched
        },
        reset() {
            dispatch.operations.stopCurrentStateJob();
        },
    }),

    reducers: {
        clearPolling(state) {
            if (state.polling) {
                clearInterval(state.polling);
                Logger.info('Polling stopped'); // Log when polling is stopped
            }
            return { ...state, polling: null };
        },
        setPolling(state, polling) {
            return { ...state, polling };
        },
    },
};

export default operations;
